import React, { useEffect, useCallback, useMemo, createContext, useRef } from 'react';

import { ContentTypesCommentService } from '../services/content-types-comment-service';

type CommentContextType = {
	commentService: ContentTypesCommentService;
};

export const CommentContext = createContext<CommentContextType | null>(null);

interface CommentProviderProps {
	children: React.ReactNode;
}

export const CommentProvider: React.FC<CommentProviderProps> = ({ children }) => {
	const commentService = useRef(new ContentTypesCommentService()).current;

	useEffect(() => {
		// Cleanup on unmount
		return () => {
			commentService.dispose();
		};
	}, [commentService]);

	const handleSelectThread = useCallback(
		(threadId?: string) => {
			commentService.selectCommentThread(threadId);
		},
		[commentService],
	);

	useEffect(() => {
		commentService.registerSelectThreadHandler(handleSelectThread);
		return () => {
			// un-set the handler on component unmount
			commentService.registerSelectThreadHandler(undefined);
		};
	}, [commentService, handleSelectThread]);

	const contextValue = useMemo(
		() => ({
			commentService,
		}),
		[commentService],
	);

	return <CommentContext.Provider value={contextValue}>{children}</CommentContext.Provider>;
};
